module.exports = __webpack_public_path__ + "static/fourth-step-apartados-59083aa1c78d88ea02829464d1be3d06.svg";